import Modal from '../../../../shared/modal';
import WebcamCapture from './CameraCapture';

const CameraModal = ({ open, onClose, setAddFile }: { open: boolean, onClose: () => void, setAddFile: (file: {
	name: string;
	url: string;
}[]) => void }) => {
	  
    return (
        <Modal 
			open={open} 
			onClose={onClose}
			contentContainerStyle='max-w-[95%] w-[500px] rounded-lg mb-4'
			title='Camera'
		>
			<div className='mt-4'>
				<WebcamCapture onClose={onClose} setAddFile={setAddFile} />
			</div>
			
        </Modal>
    )
}

export default CameraModal;